import { render, staticRenderFns } from "./menuManag.vue?vue&type=template&id=740ebb8c"
import script from "./menuManag.vue?vue&type=script&lang=js"
export * from "./menuManag.vue?vue&type=script&lang=js"
import style0 from "./menuManag.vue?vue&type=style&index=0&id=740ebb8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports